// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import store from "@/store";

const defaultSetRoute = {
    unitInfo: (route, router, unitId) => {
        let shipment = store.getters.getShipments.find(s => s.unit_id == unitId)
        router.push({
            name: route.name,
            params: {
                ...route?.params,
                shipmentId: shipment?.id
            },
            query: {...route.query}
        })
    },
}

const routes = (!['intuit.portal', 'intuit.shipments'].includes(process.env.VUE_APP_PACKAGE)) ? [] : [
    {
        path: 'shipments-locator/:packageId(\\d+)?/:shipmentId(\\d+)?',
        name: consts.routerNames.shipments_locator.main,
        meta: {
            mainRouteName: consts.routerNames.shipments_locator.main,
            showAsideMenu: false,
            isGuest: true,
            markerOnClick: true,
            weatherInMap: true,
            pageClass: 'unit-dashboard locator-page',
            showMap: true,
            unitTracking: true,
            layers: {
                ...consts.defaultSettingsLayers,
                units: {visible: false, showInList: false, showLayer: false},
                shipments_units: {visible: true, showInList: true, showLayer: true},
                shipments_tracks: {visible: true, showInList: true, showLayer: true},
            },
            setRoute: defaultSetRoute,
        },
        props: {
            default: (route) => ({shipmentId: route.params.shipmentId, packageId: route.params.packageId})
        },
        components: {
            default: () => import('@/views/intuit/portal/ShipmentsLocatorPage.vue')
        }
    },
];

export default routes;